module.exports = __webpack_public_path__ + "static/media/zippinLoading-new.2921000b.gif";